import { BrowserSuggestionPage } from './BrowserSuggestionPage';
export default BrowserSuggestionPage;